<template>
    <ul
        class="pagination flex mx-2 justify-center album_page-selector border-yellow-photo border-t pt-4"
        v-if="pages.length > 1"
    >
        <li
            class="current-album mx-2 cursor-pointer"
            v-for="(item, idx) in pages"
            :key="idx"
            @click.prevent="$emit('page-changed', item)"
        >
            <a
                class="py-2 px-3"
                :class="item == currentPage ? 'bg-yellow-photo' : ''"
            >
                {{ item }}
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        pages: {
            type: Array,
            required: true,
        },
        currentPage: {
            type: [String, Number],
            required: true,
        },
    },
};
</script>
